export default "__VITE_ASSET__CoTtRUiX__"